module.exports = __webpack_public_path__ + "img/djooky-records.2316e70f.svg";